export default __webpack_public_path__ + "eff4eae1d096c7c14a84fde4a11cc036.svg";